var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{attrs:{"variant":"warning","disabled":_vm.valorDisponivel == 0},on:{"click":function($event){$event.stopPropagation();return _vm.obterDotacoesProcesso()}}},[_c('span',[_c('i',{staticClass:"fa fa-plus mr-2"}),_vm._v(" Obter Dotações do Processo\n        ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }